// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-097d22e4]:root{--light_text_color:#666}.product-badge[data-v-097d22e4]{color:#f37053;display:inline-block;vertical-align:top;line-height:15px;font-size:11px;border:1px solid #f37053;border-radius:3px;padding:0 4px;background:#fff;margin-bottom:0;margin-top:-1px;white-space:nowrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
